import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-aterpea-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class AterpeaSpinnerComponent implements OnInit {
  @Input() message: string = 'Cargando';
  constructor() { }

  ngOnInit(): void {
  }

}
